import React from 'react';

import {
  Masthead,
  MastheadToggle,
  MastheadMain,
  MastheadLogo,
  MastheadBrand,
  Button,
  MastheadContent,
  Brand,
} from '@patternfly/react-core';

import BarsIcon from '@patternfly/react-icons/dist/js/icons/bars-icon';
import {HeaderToolbar} from './HeaderToolbar';
import {Link} from 'react-router-dom';
import {useUI} from 'src/contexts/UIContext';
import {useLogo} from 'src/hooks/UseLogo';
import './QuayHeader.css';

export function QuayHeader({toggleDrawer}: {toggleDrawer: () => void}) {
  const {toggleSidebar} = useUI();
  const logoUrl = useLogo();

  return (
    <Masthead>
      <MastheadMain>
        <MastheadToggle>
          <Button
            icon={<BarsIcon />}
            variant="plain"
            aria-label="Global navigation"
            onClick={toggleSidebar}
          />
        </MastheadToggle>
        <MastheadBrand>
          <MastheadLogo component={(props) => <Link {...props} to="/" />}>
            <Brand src={logoUrl} alt="Red Hat Quay" />
          </MastheadLogo>
        </MastheadBrand>
      </MastheadMain>
      <MastheadContent>
        <HeaderToolbar toggleDrawer={toggleDrawer} />
      </MastheadContent>
    </Masthead>
  );
}
